<div class="card">
  <div>
    <h3 class="card-title">{{ 'packages' | translate }}</h3>
  </div>
  <div class="table-responsive">
    <table class="table m-0">
      <thead>
        <tr>
          <th>{{ 'carrier' | translate }}</th>
          <th>{{ 'code' | translate }}</th>
          <th>{{ 'weight' | translate }}</th>
          <th>&nbsp;</th>
          <th>{{ 'packageStatus' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (pack of order.packages; track pack) {
          <tr>
            <td class="no-hover">{{ pack.carrier?.name }}</td>
            <td class="no-hover">{{ pack.code }}</td>
            <td class="no-hover text-right">{{ pack.weight + '&nbsp;' + 'kg' }}</td>
            <td class="no-hover">
              @if (pack.code && pack.code.length > 0) {
                <btn
                  [label]="'ticket'"
                  [icon]="'far-tag'"
                  [classes]="['btn-third', 'btn-sm']"
                  (onEvent)="downloadFromUrl(pack.ticketUrl)"
                ></btn>
              }
            </td>
            <td class="p-0 no-hover">
              <modal-process-status [package]="pack" [packageStates]="pack.statuses"></modal-process-status>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
